import store from '@/store/store';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import genererCivilite from '@/services/parametrage/generation/genererParametrageGenerique';
import { create } from '@/api/civilite/index';

export default async function getCivilite(listeCivilites) {
  await store.dispatch('parametres/loadParametres', [PARAMETRES_KEYS.civilite]);
  const civilitesParam = store.getters['parametres/parametre'](PARAMETRES_KEYS.civilite);
  let reqCivilites = [];
  [...new Set(listeCivilites)].forEach((civilite) => {
    if (civilite === undefined) return;
    const isInParam = civilitesParam.find((c) => {
      return c.libelle.toLowerCase() === civilite.toLowerCase();
    });
    if (!isInParam) {
      const newCivilite = genererCivilite();
      newCivilite.libelle = civilite;
      reqCivilites.push(create(newCivilite));
    }
  });
  if (reqCivilites.length) {
    await Promise.all(reqCivilites);
    reqCivilites = [];
    await store.dispatch('parametres/loadParametres', [PARAMETRES_KEYS.civilite]);
  }
}
